/** Ship version — keep in sync with package.json */
export const APP_VERSION = "0.5.7";
export const PHASE_LABEL =
  "Phase 5 — Soft hex · cubic wander · orbit camera · tile-only seasons";
